import { useEffect, useRef } from 'react'
import { useRestaurant } from '@local/do-secundo-restaurant-provider'
import TagManager from './TagManager'

const useGoogleTagManager = () => {
  const { applicableConfigs } = useRestaurant()
  const { pixelsConfig } = applicableConfigs

  // Initialize Google Tag Manager at most once. It prepends tags to <head> and <body>, so initializing it more than once
  // would add the tags multiple times.
  const tagManagerInitialized = useRef(false)
  useEffect(() => {
    // The Cookie Consent banner doesn't know about cookies that GTM might add,
    // so we can't use GTM for Int'l websites currently.
    if (pixelsConfig?.googleTagManager && !tagManagerInitialized.current) {
      TagManager.initialize({
        gtmId: pixelsConfig.googleTagManager
      })
      tagManagerInitialized.current = true
    }
  }, [pixelsConfig])
}

export default useGoogleTagManager
